import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { toast } from "react-toastify";
import "intro.js/introjs.css";

import Content from "./Content/Content";

import ProductModals from "./Modals/ProductModals";
import OAModals from "./Modals/OAModals";
import FilesModals from "./Modals/FilesModals";
import UtilityModals from "./Modals/UtilityModals";

import { CLEAR_MESSAGE } from "@/redux/types/message.types";
import { FINAL_LOGOUT_REQUEST } from "@/redux/types/auth.types";
import { isMobile } from "@/services/Utils";
import trackingService from "@/services/tracking.service";

import Document from "./Document/Document";
import Logout from "./Logout/Logout";
import Survey from "./Survey";

import { ReactComponent as WhatsappIcon } from "@/assets/images/desktop/whatsapp.svg";

import "./layout.styles.scss";

const Layout = (props) => {
	const dispatch = useDispatch();
	const location = useLocation();

	const { message, type } = useSelector((state) => state.message);
	const { user, isFetchingLogout } = useSelector((state) => state.auth);

	const lastMessageRef = useRef(null);

	useEffect(() => {
		void trackingService.trackPageView(location.pathname).catch(() => {});
	}, [location.pathname]);

	useEffect(() => {
		if (message && message !== lastMessageRef.current) {
			lastMessageRef.current = message;
			toast(message, { type });

			dispatch({
				type: CLEAR_MESSAGE,
			});
		}
	}, [message, type, dispatch]);

	if ((isFetchingLogout && user) || typeof user === "string") {
		dispatch({
			type: FINAL_LOGOUT_REQUEST,
		});
	}

	return (
		<div className={`App wrapper ${isMobile() && "is_mobile"}`}>
			<Document />
			<Logout />
			<Content props={props} />
			<Survey />

			<ProductModals />
			<OAModals />
			<FilesModals />
			<UtilityModals />

			<OverlayTrigger overlay={<Tooltip>Necesitas ayuda?</Tooltip>}>
				<WhatsappIcon
					onClick={() => window.open("https://wa.me/56963175034?text=Hola, necesito ayuda.", "_blank", "noopener,noreferrer")}
					className="whatsapp-help"
				/>
			</OverlayTrigger>
		</div>
	);
};

export default Layout;
